module.exports = __webpack_public_path__ + "static/media/circle-minus-blue.2881ee12.svg";